export default __webpack_public_path__ + "static/media/lock.d715f9e6.svg";